import { useState, lazy, Suspense } from 'react';
import { X, Calendar as CalendarIcon, Loader2 } from 'lucide-react';

const CalendarDashboard = lazy(() => import('../pages/CalendarDashboard.jsx'));

export default function GlobalCalendarDrawer({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/50 z-50 transition-opacity" onClick={onClose} />
      <div
        className={`fixed inset-y-0 right-0 z-50 w-full max-w-[70dvw] bg-background shadow-2xl border-l border-border transform transition-transform duration-300 flex flex-col`}
      >
        <div className="flex items-center justify-between p-4 border-b border-border bg-card shrink-0">
          <div className="flex items-center gap-2">
            <CalendarIcon className="w-5 h-5 text-primary" />
            <h2 className="font-bold text-lg text-foreground">Global Calendar</h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-accent rounded-xl text-muted-foreground hover:text-foreground transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto overflow-x-hidden">
          <div className="p-4">
            <Suspense
              fallback={
                <div className="flex items-center justify-center p-12 text-muted-foreground">
                  <Loader2 className="h-6 w-6 animate-spin" />
                </div>
              }
            >
              <CalendarDashboard />
            </Suspense>
          </div>
        </div>
      </div>
    </>
  );
}
